var map = {
	"./slider-home-1.png": "c8b0",
	"./slider-home-1@2x.png": "a284",
	"./slider-home-1@3x.png": "97ec",
	"./slider-home-2.png": "d0e1",
	"./slider-home-2@2x.png": "1ad1",
	"./slider-home-2@3x.png": "c3ae",
	"./slider-home-3.png": "d37c",
	"./slider-home-3@2x.png": "bef2",
	"./slider-home-3@3x.png": "4462"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2295";